import script from "./MTB_Setup_Device.vue?vue&type=script&setup=true&lang=js"
export * from "./MTB_Setup_Device.vue?vue&type=script&setup=true&lang=js"

import "./MTB_Setup_Device.vue?vue&type=style&index=0&id=2598f190&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2598f190"]])

export default __exports__